module.exports = __webpack_public_path__ + "img/mestre_glaucoma.31f79a4d.png";